import $ from 'jquery'

function initPage () {
	// catchAnchor();
	resetAnchor()
	bodyClasses()
}

function resetAnchor () {
	if (location.hash) {               // do the test straight away
		window.scrollTo(0, 0)         // execute it straight away
		setTimeout(function () {
			window.scrollTo(0, 0)     // run it a bit later also for browser compatibility
		}, 1)
	}
}

function bodyClasses () {
	const $body = $('body')

	$(document).on('pub:unscrolled', function () {
		$body.addClass('unscrolled').removeClass('scrolled')
	})
	$(document).on('pub:scrolled', function () {
		$body.addClass('scrolled').removeClass('unscrolled')
	})

	$(document).on('pub:viewport', function (event, device) {
		$body.removeClass('device-mobile device-tablet device-desktop device-ultra device-custom portrait landscape small')
		document.device = device
		$body.addClass(' device-' + device)


//		appHeight()
	})


	const appHeight = () => {
		const doc = document.documentElement;
//		//console.log(doc);
//		 doc.style.setProperty('--app-height', `${window.innerHeight}px`);

		$('body section.summary').css('height',`${window.innerHeight - 80}px`);
	}
}

export default initPage
